import styled from 'styled-components/macro';
import styles from '../../ui/styles';

const Wrapper = styled.div`
  position: relative;
  ${styles.mediaBlock}

  .imgWrapper {
    position: relative;
    width: 100%;
    margin-left: 0;

    & > img {
      width: 100%;
    }
  }
`;

export default Wrapper;
